import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Paragraph from '../../components/Paragraph'
import Prompts from '../../components/Prompts'
import lang from '../../stores/lang'
import patient from '../../stores/patient'
import getQualities from '../../utils/getQualities'
import pickTwoFromArr from '../../utils/pickTwoFromArr'
import Text from "../../components/Text";
import SummaryBullet from "../../components/SummaryBullet";

@observer
export default class PostStrengthsPrompts extends Component {
  render() {
    const strengthKeys = pickTwoFromArr(patient.fields.strengths)
    const qualityKeys = pickTwoFromArr(getQualities(strengthKeys))
    const strengths = strengthKeys.map(v => lang.translate(`choices.strength.${v}`).toLowerCase())
    const qualities = qualityKeys.map(v => lang.translate(`choices.quality.${v}`).toLowerCase())
    const confidenceScore = Number(patient.fields.confidence)
    const shouldUseSinglePriorStrengthPrompt = (
      !Number.isNaN(confidenceScore) &&
      confidenceScore <= 6 &&
      patient.fields.strengths.length === 1
    )

    return (
      <Prompts>
        {patient.fields.strengths.length !== 0 &&
          <Fragment>
            <Prompts.Q
              str={strengths.length === 1
                ? "prose.youreGoodAtSingular"
                : "prose.youreGoodAtPlural"
              }
              inserts={strengths.length === 1
                ? { s: strengths[0] }
                : { s1: strengths[0], s2: strengths[1] }
              }
            />
            <Prompts.R>
              <Paragraph
                str={strengths.length === 1
                  ? "prose.workAtBecomingSingular"
                  : "prose.workAtBecomingPlural"
                }
                inserts={strengths.length === 1
                  ? { s: strengths[0], q1: qualities[0], q2: qualities[1] }
                  : { s1: strengths[0], s2: strengths[1], q1: qualities[0], q2: qualities[1] }
                }
              />
              <Paragraph str="prose.orIfTheySay" centered />
              <Paragraph
                str={strengths.length === 1
                  ? "prose.itSoundsLikeGoodAtStrengthsSingular"
                  : "prose.itSoundsLikeGoodAtStrengthsPlural"
                }
                inserts={strengths.length === 1
                  ? { s: strengths[0], q1: qualities[0], q2: qualities[1] }
                  : { s1: strengths[0], s2: strengths[1], q1: qualities[0], q2: qualities[1] }
                }
              />
            </Prompts.R>
            <Prompts.Q
              str="prose.imagineApplyingStrengths"
              inserts={{ q1: qualities[0], q2: qualities[1] }}
            />
            <Prompts.R>
              <Paragraph str="prose.itSoundsLike" />
              <Paragraph><center><Text str="prose.ifTheySayDontKnow"/></center></Paragraph>
              {shouldUseSinglePriorStrengthPrompt
                ? (
                  <Paragraph
                    str="prose.capableApplySkillsToRoutine"
                    inserts={{ q1: qualities[0], q2: qualities[1] }}
                  />
                )
                : <Paragraph str="prose.youHaveStrength" />
              }
            </Prompts.R>
          </Fragment>
        }
        <Prompts.S>
          <Paragraph str="prose.nextLikeToReviewUse" />
          <SummaryBullet color="blue" icon="far fa-dot-circle">
            <Text str="prose.youHaveBeenDiagnosedWith" />&nbsp;&nbsp;
            <Text str={`choices.diagnosis.${patient.fields.diagnosis}`} />
          </SummaryBullet>
          {patient.hasVFIs &&
            <Fragment>
              <Paragraph str="prose.and" />
              <SummaryBullet color="blue" icon="fas fa-eye">
                {patient.mostRecentLeftVFI && <Text str="prose.yourVisionInLeftEye" inserts={{ vfi: patient.mostRecentLeftVFI }} />}
                {patient.mostRecentLeftVFI && patient.mostRecentRightVFI && <br />}
                {patient.mostRecentRightVFI && <Text str="prose.yourVisionInRightEye" inserts={{ vfi: patient.mostRecentRightVFI }} />}
              </SummaryBullet>
            </Fragment>
          }
        </Prompts.S>
        <Prompts.P>
          <Text str="prose.lifeStyleQuestions"/>
        </Prompts.P>
      </Prompts>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/PostStrengthsPrompts2.js